<template>
  <div class="manage">
    <p class="text-h6">管理者画面</p>
    <div class="text-center" v-if="isRendering">
      <v-progress-circular indeterminate color="secondary" />
    </div>
    <div v-if="!isRendering && !isManager">
      <v-alert
        border="left"
        colored-border
        type="error"
        elevation="1"
        style="font-size: 90%"
        class="my-6"
      >
        管理者権限がありません。
      </v-alert>
    </div>
    <div v-if="!isRendering &&isManager">
      <div class="mb-6 group-table">
        <h4 class="manage-group-title">◇あなたが管理者であるグループ</h4>
        <v-alert
          border="left"
          colored-border
          type="warning"
          elevation="2"
          style="font-size: 90%"
        >
          ダウンロードファイルにはパスワードがかかっています。<br/>
          パスワードは健保共通PWを設定しています。最新のパスワードで開けない場合は、旧パスワードでご確認ください。<br/>
        </v-alert>
        <v-alert
          v-if="searchCsvStatus==='creating_result_detail'"
          border="left"
          colored-border
          type="info"
          elevation="2"
          style="font-size: 90%"
        >
          CSVを生成しています。ブラウザのタブを閉じずに少々お待ちください。（生成には最大15分かかる場合がございます。）
          <br>
          生成が終了次第にCSVファイルがダウンロードされます。 CSVの生成は記録や掲示板等の画面操作を行っても継続されます。
        </v-alert>
        <v-simple-table dense style="width: 100%">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="width: 50%">事業所名</th>
                <th class="text-left" style="width: 15%">在籍者マスタ登録数</th>
                <th class="text-left" style="width: 15%" v-if="campaign.is_prize">達成賞人数
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="blue" v-bind="attrs" v-on="on" style="margin-left:10px">
                        mdi-help-circle
                      </v-icon>
                    </template>
                    <span>達成賞人数は1時間に1回更新されます。(9時から21時)</span>
                  </v-tooltip>
                </th>
                <th class="text-left">取り組み結果CSV</th>
                <th class="text-left">参加者リスト１</th>
                <th class="text-left">参加者リスト２</th>
              </tr>
            </thead>
            <tbody v-if="listOffice.length > 0">
              <tr v-for="office of listOffice" :key="office.id">
                <td>{{office.name}}</td>
                <td>{{office.person_enrollment_user_count}}</td>
                <td v-if="campaign.is_prize">{{office.person_prizewinner_count}}</td>
                <td>
                  <a
                    v-if="searchCsvStatus==='untreated'"
                    hlef="#"
                    @click="genearateCSVKey('result_detail', office.id)"
                  >
                    CSV
                  </a>
                  <div v-if="searchCsvStatus==='creating_result_detail'">
                    <v-progress-linear indeterminate color="info"></v-progress-linear>
                  </div>
                </td>
                <td>
                  <div v-if="office.userListStatus">
                    <a hlef="#" @click="downloadXlsx(office.id, 'user_list')">出力</a>
                  </div>
                </td>
                <td>
                  <div v-if="office.completedListStatus">
                    <a hlef="#" @click="downloadXlsx(office.id, 'completed_list')">出力</a>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <div v-if="listOffice.length > 0">
        <h4 class="manage-group-title">◇ユーザー一覧</h4>
        <div class="mr-4 ml-4 mt-4" v-if="!isMobile">
          <v-row dense>
            <v-col cols="4">
              <div>
                <v-select
                  v-bind:value="disp_office_id_list"
                  @change="office_id_list = $event"
                  :items="createOfficeOptionsList(listOffice)"
                  return-object
                  hide-details="auto"
                  outlined
                  dense
                  sm="6"
                  md="1"
                  :disabled="isLoading || isNextSearch"
                  :label="'事業所名'"
                ></v-select>
              </div>
            </v-col>
            <v-col cols="4">
              <div>
                <v-text-field
                  @input="affiliation_name = $event"
                  outlined
                  dense
                  :disabled="isLoading || isNextSearch"
                  :label="'所属名'"
                  />
              </div>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="2" v-if="campaign.is_prize">
              <div>
                <v-checkbox
                  @change="is_prizewinner = $event"
                  :disabled="isLoading || isNextSearch"
                  :label="'達成賞フラグ'"
                  class="mt-1"
                  />
              </div>
            </v-col>
            <v-col cols="2" v-if="campaign.is_continue_bonus">
              <div>
                <v-checkbox
                  @change="is_continue_bonus_complete = $event"
                  :disabled="isLoading || isNextSearch"
                  :label="'継続ボーナス対象フラグ'"
                  class="mt-1"
                  />
              </div>
            </v-col>
            <v-col cols="2" v-if="campaign.required_advanced_course_count > 0">
              <div>
                <v-select
                  @change="advanced_course = $event.value"
                  :items="createCourseOptionsList()"
                  return-object
                  hide-details="auto"
                  outlined
                  dense
                  :disabled="isLoading || isNextSearch"
                  :label="'選択アドバンスコース数'"
                ></v-select>
              </div>
            </v-col>
            <v-col cols="2" v-if="campaign.required_advanced_course_count > 0">
              <div>
                <v-select
                  @change="completed_advanced_course = $event.value"
                  :items="createCourseOptionsList()"
                  return-object
                  hide-details="auto"
                  outlined
                  dense
                  :disabled="isLoading || isNextSearch"
                  :label="'達成アドバンスコース数'"
                ></v-select>
              </div>
            </v-col>
            <v-col cols="2" v-if="campaign.is_team">
              <div>
                <v-text-field
                  @input="team_name = $event"
                  outlined
                  dense
                  :disabled="isLoading || isNextSearch"
                  :label="'チーム名'"
                  />
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="ma-4" v-if="isMobile">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                検索条件
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense>
                  <v-col cols="12">
                    <div>
                      <v-select
                        v-bind:value="disp_office_id_list"
                        @change="office_id_list = $event"
                        :items="createOfficeOptionsList(listOffice)"
                        return-object
                        hide-details="auto"
                        outlined
                        dense
                        sm="6"
                        md="1"
                        :disabled="isLoading || isNextSearch"
                        :label="'事業所名'"
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12">
                    <div class="mt-5">
                      <v-text-field
                        @input="affiliation_name = $event"
                        outlined
                        dense
                        :disabled="isLoading || isNextSearch"
                        :label="'所属名'"
                        />
                    </div>
                  </v-col>
                </v-row>
                <v-row dense v-if="campaign.is_prize">
                  <v-col cols="12">
                    <div>
                      <v-checkbox
                        @change="is_prizewinner = $event"
                        :disabled="isLoading || isNextSearch"
                        :label="'達成賞フラグ'"
                        class="mt-0"
                        />
                    </div>
                  </v-col>
                </v-row>
                <v-row dense v-if="campaign.is_continue_bonus">
                  <v-col cols="12">
                    <div>
                      <v-checkbox
                        @change="is_continue_bonus_complete = $event"
                        :disabled="isLoading || isNextSearch"
                        :label="'継続ボーナス対象フラグ'"
                        class="mt-0"
                        />
                    </div>
                  </v-col>
                </v-row>
                <v-row dense v-if="campaign.required_advanced_course_count > 0">
                  <v-col cols="12">
                    <div class="mb-5">
                      <v-select
                        @input="advanced_course = $event.value"
                        :items="createCourseOptionsList()"
                        return-object
                        hide-details="auto"
                        outlined
                        dense
                        :disabled="isLoading || isNextSearch"
                        :label="'選択アドバンスコース数'"
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
                <v-row dense v-if="campaign.required_advanced_course_count > 0">
                  <v-col cols="12">
                    <div class="mb-5">
                      <v-select
                        @change="completed_advanced_course = $event.value"
                        :items="createCourseOptionsList()"
                        return-object
                        hide-details="auto"
                        outlined
                        dense
                        :disabled="isLoading || isNextSearch"
                        :label="'達成アドバンスコース数'"
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
                <v-row dense v-if="campaign.is_team">
                  <v-col cols="12">
                    <div>
                      <v-text-field
                        @input="team_name = $event"
                        outlined
                        dense
                        :disabled="isLoading || isNextSearch"
                        :label="'チーム名'"
                        />
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <v-btn
          @click="searchUser"
          class="mr-4 ml-4 mb-4"
          color="info"
          styke="margin-top: 0px !important"
          :loading="isLoading || isNextSearch"
        >
          検索
        </v-btn>
        <v-btn
          v-if="searchCsvStatus==='untreated'"
          @click.prevent="genearateCSVKey('search_user')"
          outlined
          class="mr-4 ml-4 mb-4"
          styke="margin-top: 0px !important"
          color="info"
          :loading="isLoading || isNextSearch"
        >
          CSV出力
        </v-btn>
        <v-btn
          v-if="searchCsvStatus==='creating'"
          outlined
          class="mr-4 ml-4 mb-4"
          styke="margin-top: 0px !important"
          color="info"
          :disabled="true"
        >
          CSV生成中
        </v-btn>
        <v-alert
          v-if="searchCsvStatus==='creating'"
          border="left"
          colored-border
          type="info"
          elevation="2"
          style="font-size: 90%"
        >
          CSVを生成しています。ブラウザのタブを閉じずに少々お待ちください。（生成には最大15分かかる場合がございます。）
          <br>
          生成が終了次第にCSVファイルがダウンロードされます。 CSVの生成は記録や掲示板等の画面操作を行っても継続されます。
        </v-alert>
      </div>
      <div class="mt-4 mb-6 user-table" v-if="listUser.length > 0">
        <v-alert
          v-if="(this.nextToken || this.nextTokenSeconded || this.nextStartSeconded) && listUser.length === 1000"
          border="left"
          colored-border
          type="info"
          elevation="2"
          style="font-size: 90%"
        >
          先頭の1000件を表示しています。1000件以降のデータを閲覧したい場合は「さらに4000件取得」より取得してください。<br/>
          番号で正しく並び替えが行われない場合がございますので、1000件以降のデータを取得した後に並び替えをお試しください。
        </v-alert>
        <v-alert
          v-if="listUser.length >= 5000"
          border="left"
          colored-border
          type="info"
          elevation="2"
          style="font-size: 90%"
        >
          先頭の5000件を表示しています。条件を絞って検索してください。
        </v-alert>
        <div style="display: flow-root">
          <div style="float: left">
            <v-dialog
              v-model="dialog"
              persistent
              max-width="600px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-4"
                  v-bind="attrs"
                  v-on="on"
                  :isLoading="isNextSearch"
                >
                  備考一括更新
                </v-btn>
              </template>
              <v-form ref="post_note_form">
                <v-card>
                  <v-card-title>
                    <span class="headline">備考一括更新</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col>
                          <v-textarea
                            :key="resetSwitch"
                            @input="note = $event"
                            outlined
                            dense
                            name="comment"
                            label="備考"
                            :rules="upper_limit_rules"
                          ></v-textarea>
                          <span class="red--text">※機種依存文字などの特殊文字（例：♡、©、㌕）は使用しないでください</span>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        :loading="isLoading"
                        @click="updateNote"
                      >
                        一括更新
                      </v-btn>
                      <v-btn
                        @click="chancel"
                      >
                        キャンセル
                      </v-btn>
                    </v-card-actions>
                  </v-card-text>
                </v-card>
              </v-form>
            </v-dialog>
            <v-btn
              @click="nextSearchUser"
              v-if="(this.nextToken || this.nextTokenSeconded || this.nextStartSeconded) && listUser.length < 5000"
              class="mb-4 ml-4"
              color="info"
              :loading="isNextSearch"
            >
              さらに4000件取得
            </v-btn>
          </div>
        </div>
        <v-data-table
          dense
          :headers="tableHeaders"
          :items="listUser"
          :items-per-page="1000"
          locale="ja-jp"
          fixed-header
          multi-sort
          :footer-props="{
            itemsPerPageOptions: [1000],
            showFirstLastPage: true,
            showCurrentPage: true
          }"
        >
          <template v-slot:[`item.checked`]="{item}">
            <input type="checkbox" v-model="item.checked"/>
          </template>
          <template v-slot:[`item.questionnaire_answer_at`]="{ item }">
            <v-icon v-if="item.questionnaire_answer_at" small>mdi-check</v-icon>
          </template>
          <template v-slot:[`item.is_prizewinner`]="{ item }">
            <v-icon v-if="item.is_prizewinner || item.is_app_completed || item.is_no_smoking_completed" small>mdi-check</v-icon>
          </template>
          <template v-slot:[`item.app_questionnaire_info_first`]="{ item }">
            <v-icon v-if="item.app_questionnaire_info_first" small>mdi-check</v-icon>
          </template>
          <template v-slot:[`item.app_questionnaire_info_second`]="{ item }">
            <v-icon v-if="item.app_questionnaire_info_second" small>mdi-check</v-icon>
          </template>
          <template v-slot:[`item.is_app_completed`]="{ item }">
            <v-icon v-if="item.is_app_completed" small>mdi-check</v-icon>
          </template>
          <template v-slot:[`item.username`]="{ item }">
            <div v-if="item.username && item.selected_course > 0">
              <a
                v-if="searchCsvStatus==='untreated'"
                hlef="#"
                @click="genearateCSVKey('user_result', null, item)"
              >
                CSV
              </a>
              <div v-if="searchCsvStatus==='creating_user_result'">
                <v-progress-linear indeterminate color="info"></v-progress-linear>
              </div>
            </div>
          </template>
          <template v-slot:[`item.is_continue_bonus_complete`]="{ item }">
            <v-icon v-if="item.is_continue_bonus_complete" small>mdi-check</v-icon>
          </template>
          <template v-slot:[`footer.page-text`]="{ pageStart, pageStop, itemsLength }">
            {{ pageStart }} - {{ pageStop }} 件目 /  {{ itemsLength }} 件
          </template>
        </v-data-table>
      </div>
      <v-alert
        v-if="listUser.length === 0 && !isLoading && isSearch"
        border="left"
        colored-border
        type="info"
        elevation="2"
        style="font-size: 90%"
      >
        該当データが存在しません。
      </v-alert>
    </div>

    <!--共通コンポーネント-->
    <Dialog ref="confirm"/>
    <SuccessSnackbar ref="snackbar"/>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import dayjs from 'dayjs'
const SuccessSnackbar = () => import('../util/SuccessSnackbar.vue')
const Dialog = () => import('../util/Dialog.vue')

const listOfficeQuery = (campaignId) => `
  query listOffice {
    listOffice(campaign_id: "${campaignId}") {
      offices {
        id
        name
        person_enrollment_user_count
        person_prizewinner_count
      }
      total_person_enrollment_user_count
      total_person_prizewinner_count
    }
  }
`
const getListOffice = async (campaignId) => {
  const { data: { listOffice: data } } = await GraphqlAPI(listOfficeQuery(campaignId))
  return {
    offices: data.offices.map((item) => {
      return {
        id: item.id,
        name: item.name,
        person_enrollment_user_count: item.person_enrollment_user_count,
        person_prizewinner_count: item.person_prizewinner_count
      }
    })
  }
}

const convertInputString = (input) => {
  if (!input) {
    return null
  }
  const arr = Object.keys(input).map(key => {
    if (input[key] instanceof Array) {
      const inputArry = input[key]
      const strArry = inputArry.map(item => JSON.stringify(item))
      const arrStr = `[${strArry.join(', ')}]`
      return `${key}: ${arrStr}`
    } else if (typeof input[key] === 'number' || typeof input[key] === 'boolean') {
      return `${key}: ${input[key]}`
    } else if (input[key]) {
      return `${key}: ${JSON.stringify(input[key])}`
    }
  })
  return `{${arr.join(', ')}}`
}

const searchUserQuery = (input, campaignId, limit) => `
  query searchUser {
    searchUser(
      input: ${convertInputString(input)}
      campaign_id: "${campaignId}"
      direction: ASC
      limit: ${limit}
    ) {
      users {
        username
        certificate_number
        name
        office_name
        seconded_code
        seconded_name
        affiliation_name
        note
        campaign_user_created_at
        selected_course
        advanced_course
        completed_course
        completed_advanced_course
        questionnaire_answer_at
        is_prizewinner
        last_record_at
        team_name
        team_average_point
        team_rank
        app_name
        continue_bonus_point
        is_continue_bonus_complete
        app_questionnaire_info {
          first
          second
        }
        app_point
        is_app_completed
        enrollment_user_id
        is_no_smoking_completed
        selected_course_pack
        total_steps
        current_walking_point
      }
      count
      next_token {
        id
        meta
        next_symbol
      }
      next_token_seconded {
        id
        meta
        certificate_number
        seconded_code
        next_symbol
      }
      next_start_seconded
    }
    listCoursePack(campaign_id: "${campaignId}") {
      course_packs {
        pack_name
        id
      }
    }
  }
`
const getSearchUser = async (input, campaignId, limit) => {
  const { data: { searchUser: data, listCoursePack: { course_packs: coursePacks } } } = await GraphqlAPI(searchUserQuery(input, campaignId, limit))
  return {
    users: data.users.map((item) => {
      return {
        ...item,
        app_questionnaire_info_first: item.app_questionnaire_info ? item.app_questionnaire_info.first : false,
        app_questionnaire_info_second: item.app_questionnaire_info ? item.app_questionnaire_info.second : false
      }
    }),
    coursePacks,
    next_token: data.next_token,
    next_token_seconded: data.next_token_seconded,
    next_start_seconded: data.next_start_seconded,
    count: data.count
  }
}
const searchUserQueryNext = (input, campaignId, limit, nextToken, nextTokenSeconded, nextStartSeconded) => `
  query searchUser {
    searchUser(
      input: ${convertInputString(input)}
      campaign_id: "${campaignId}"
      direction: ASC
      limit: ${limit}
      next_token: ${convertInputString(nextToken)}
      next_token_seconded: ${convertInputString(nextTokenSeconded)}
      next_start_seconded: ${nextStartSeconded}
    ) {
      users {
        username
        certificate_number
        name
        office_name
        seconded_code
        seconded_name
        affiliation_name
        note
        campaign_user_created_at
        selected_course
        advanced_course
        completed_course
        completed_advanced_course
        questionnaire_answer_at
        is_prizewinner
        last_record_at
        team_name
        team_average_point
        team_rank
        app_name
        continue_bonus_point
        is_continue_bonus_complete
        app_questionnaire_info {
          first
          second
        }
        app_point
        is_app_completed
        enrollment_user_id
        is_no_smoking_completed
        selected_course_pack
        total_steps
        current_walking_point
      }
      count
      next_token {
        id
        meta
        next_symbol
      }
      next_token_seconded {
        id
        meta
        certificate_number
        seconded_code
        next_symbol
      }
      next_start_seconded
    }
  }
`
const getSearchUserNext = async (input, campaignId, limit, nextToken, nextTokenSeconded, nextStartSeconded) => {
  const { data: { searchUser: data } } = await GraphqlAPI(searchUserQueryNext(input, campaignId, limit, nextToken, nextTokenSeconded, nextStartSeconded))
  return {
    users: data.users.map((item) => {
      return {
        ...item,
        app_questionnaire_info_first: item.app_questionnaire_info ? item.app_questionnaire_info.first : false,
        app_questionnaire_info_second: item.app_questionnaire_info ? item.app_questionnaire_info.second : false
      }
    }),
    next_token: data.next_token,
    next_token_seconded: data.next_token_seconded,
    next_start_seconded: data.next_start_seconded,
    count: data.count
  }
}

const csvGenerateKeyQuery = (type, csvFormat, request) => `
  query csvSearchUserGenerateKey {
    csvSearchUserGenerateKey(
      type: "${type}"
      csv_format: "${csvFormat}"
      request: {
        campaign_id: "${request.campaign_id}"
        direction: "${request.direction}"
        input: ${convertInputString(request.input)}
      }
    ) {
      s3_key
    }
  }
`
const getCsvGenerateKeyQuery = async (type, csvFormat, request) => {
  const { data: { csvSearchUserGenerateKey: data } } = await GraphqlAPI(csvGenerateKeyQuery(type, csvFormat, request))
  return data
}
const convertArrayString = (arrayData) => {
  const resArry = arrayData.map(item => {
    return JSON.stringify(item)
  })
  return `[${resArry.join(', ')}]`
}
const updateNoteMutation = (campaignId, userIdList, inputNote) => `
  mutation updateNote {
    updateNote(
      campaign_id: "${campaignId}",
      enrollment_user_id_list: ${convertArrayString(userIdList)},
      input: {
        note: ${JSON.stringify(inputNote)}
      }
    ) {
      users {
        id
        note
      }
    }
  }
`
const registerUpdateNote = async (campaignId, userIdList, inputNote) => {
  const { data: { updateNote: data } } = await GraphqlAPI(updateNoteMutation(campaignId, userIdList, inputNote))
  return {
    users: data.users.map((item) => {
      return {
        id: item.id,
        note: item.note
      }
    })
  }
}
const checkExistPreSignedUrlQuery = (campaignId, officeIdList) => `
  query checkExistPreSignedUrl {
    checkExistPreSignedUrl(
      campaign_id: "${campaignId}",
      office_id_list: ${convertArrayString(officeIdList)}
    ) {
      offices {
        office_id
        user_list_status
        completed_list_status
      }
    }
  }
`
const checkExistPreSignedUrl = async (campaignId, officeIdList) => {
  const { data: { checkExistPreSignedUrl: data } } = await GraphqlAPI(checkExistPreSignedUrlQuery(campaignId, officeIdList))
  return {
    offices: data.offices.map((item) => {
      return {
        office_id: item.office_id,
        user_list_status: item.user_list_status,
        completed_list_status: item.completed_list_status
      }
    })
  }
}
const getUserListPreSignedUrlQuery = (officeId, listType, campaignId) => `
  query getUserListPreSignedUrl {
    getUserListPreSignedUrl(
      office_id: "${officeId}"
      list_type: "${listType}"
      campaign_id: "${campaignId}"
    ) {
      office_id
      list_type
      pre_signed_url
      exist_status
    }
  }
`
const getUserListPreSignedUrl = async (officeId, listType, campaignId) => {
  const { data: { getUserListPreSignedUrl: data } } = await GraphqlAPI(getUserListPreSignedUrlQuery(officeId, listType, campaignId))
  return {
    office_id: data.office_id,
    list_type: data.list_type,
    pre_signed_url: data.pre_signed_url,
    exist_status: data.exist_status
  }
}

const csvCheckStatusQuery = (campaignId, s3Key) => `
  query csvCheckStatus {
    csvCheckStatus(
      campaign_id: "${campaignId}",
      s3_key: "${s3Key}"
    ) {
      status
      s3_key
    }
  }
`
const getCsvCheckStatusQuery = async (campaignId, s3Key) => {
  const { data: { csvCheckStatus: data } } = await GraphqlAPI(csvCheckStatusQuery(campaignId, s3Key))
  return data
}
const csvGetPreSignedUrlQuery = (s3Key, campaignId) => `
  query csvGetPreSignedUrl {
    csvGetPreSignedUrl(
      s3_key: "${s3Key}"
      campaign_id: "${campaignId}"
    ) {
      status
      pre_signed_url
    }
  }
`
const getCsvGetPreSignedUrlQuery = async (s3Key, campaignId) => {
  const { data: { csvGetPreSignedUrl: data } } = await GraphqlAPI(csvGetPreSignedUrlQuery(s3Key, campaignId))
  return data
}

const getUserViewQuery = (campaignId) => `
  query getUserView {
    getUserView(campaign_id: "${campaignId}") {
      is_manager
    }
  }
`
const getUserViewInfo = async (campaignId) => {
  const { data: { getUserView: data } } = await GraphqlAPI(getUserViewQuery(campaignId))
  return data
}

export default {
  name: 'manage',
  components: {
    SuccessSnackbar,
    Dialog
  },
  data () {
    return {
      dialog: false,
      isManager: false,
      isSearch: false,
      isLoading: false,
      isRendering: false,
      isNextSearch: false,
      listOffice: [],
      listUser: [],
      nextToken: null,
      nextTokenSeconded: null,
      nextStartSeconded: null,
      disp_office_id_list: [],
      office_id_list: [],
      affiliation_name: '',
      is_prizewinner: false,
      is_continue_bonus_complete: false,
      advanced_course: '',
      completed_advanced_course: '',
      team_name: '',
      note: '',
      resetSwitch: false,
      tableHeaders: [
        { text: '選択', value: 'checked', sortable: false, width: '2%', class: 'pl-2 pr-1' },
        { text: '記号', value: 'symbol', class: 'pl-2 pr-1' },
        { text: '番号', value: 'number', class: 'pl-2 pr-1' },
        { text: '氏名', value: 'name', sortable: false, class: 'pl-2 pr-1' },
        { text: '事業所名', value: 'office_name', class: 'pl-2 pr-1' },
        { text: '出向先名', value: 'seconded_name', class: 'pl-2 pr-1' },
        { text: '所属名', value: 'affiliation_name', class: 'pl-2 pr-1' },
        { text: '備考', value: 'note', class: 'pl-2 pr-1' },
        { text: '初回登録日', value: 'campaign_user_created_at', class: 'pl-2 pr-1' }
      ],
      upper_limit_rules: [
        value => !(value && value.length > 80) || '80文字以下で入力してください'
      ],
      full_s3_key: '',
      searchCsvStatus: 'untreated'
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    campaignOption () {
      return this.$store.getters.getCampaignOption
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    this.isRendering = true
    await this.fetchlistOffice()
    await this.fetchCheckExistPreSignedUrl()
    this.setColumns()
    this.isManager = (await getUserViewInfo(this.campaign.id)).is_manager
    this.isRendering = false
  },
  methods: {
    setColumns () {
      if (this.campaignOption.is_course_pack) {
        this.tableHeaders.push({ text: '選択パック名', value: 'selected_course_pack_name', class: 'pl-2 pr-1' })
      }
      this.tableHeaders.push({ text: '選択コース数', value: 'selected_course', width: '3%', class: 'pl-2 pr-1' })
      if (this.campaign.required_advanced_course_count > 0) {
        this.tableHeaders.push({ text: '選択アドバンスコース数', value: 'advanced_course', width: '3%', class: 'pl-2 pr-1' })
      }
      this.tableHeaders.push({ text: '達成コース数', value: 'completed_course', width: '3%', class: 'pl-2 pr-1' })
      if (this.campaign.required_advanced_course_count > 0) {
        this.tableHeaders.push({ text: '達成アドバンスコース数', value: 'completed_advanced_course', width: '3%', class: 'pl-2 pr-1' })
      }
      if (this.campaignOption.is_walking_travel) {
        this.tableHeaders.push({ text: '地点', value: 'current_walking_point', width: '3%', class: 'pl-2 pr-1' })
        this.tableHeaders.push({ text: '歩数', value: 'total_steps', width: '3%', class: 'pl-2 pr-1' })
      }
      if (this.campaign.is_questionnaire) {
        this.tableHeaders.push({ text: 'アンケート回答', value: 'questionnaire_answer_at', width: '3%', class: 'pl-2 pr-1' })
      }
      if (this.campaign.is_prize) {
        this.tableHeaders.push({ text: '達成賞対象', value: 'is_prizewinner', width: '3%', class: 'pl-2 pr-1' })
      }
      if (this.campaign.is_continue_bonus) {
        this.tableHeaders.push({ text: 'クローバーマーク獲得数', value: 'continue_bonus_point', width: '3%', class: 'pl-2 pr-1' })
        this.tableHeaders.push({ text: '継続ボーナス対象', value: 'is_continue_bonus_complete', width: '3%', class: 'pl-2 pr-1' })
      }
      this.tableHeaders.push({ text: '最終記録日', value: 'last_record_at', class: 'pl-2 pr-1' })
      if (this.campaign.is_team) {
        this.tableHeaders.push({ text: 'チーム名', value: 'team_name', class: 'pl-2 pr-1' })
        this.tableHeaders.push({ text: 'チーム平均ポイント', value: 'team_average_point', class: 'pl-2 pr-1' })
        this.tableHeaders.push({ text: 'チーム順位', value: 'team_rank', class: 'pl-2 pr-1' })
      }
      if (this.campaign.is_app_challenge) {
        this.tableHeaders.push({ text: 'アプリコース名', value: 'app_name', class: 'pl-2 pr-1' })
        this.tableHeaders.push({ text: 'アプリアンケート1回目', value: 'app_questionnaire_info_first', width: '3%', class: 'pl-2 pr-1' })
        this.tableHeaders.push({ text: 'アプリアンケート2回目', value: 'app_questionnaire_info_second', width: '3%', class: 'pl-2 pr-1' })
        this.tableHeaders.push({ text: 'アプリポイント', value: 'app_point', class: 'pl-2 pr-1' })
        this.tableHeaders.push({ text: 'アプリ達成賞', value: 'is_app_completed', width: '3%', class: 'pl-2 pr-1' })
      }
      this.tableHeaders.push({ text: '結果詳細', value: 'username', sortable: false, width: '3%', class: 'pl-2 pr-1' })
    },
    async fetchlistOffice () {
      try {
        // 事業所一覧取得
        const getListOfficeResult = await getListOffice(this.campaign.id)
        this.listOffice = getListOfficeResult.offices
        this.disp_office_id_list = this.listOffice.map(office => office.id)
        this.office_id_list = this.disp_office_id_list
      } catch (e) {
        this.$emit('errorHandling', '事業所の取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async fetchCheckExistPreSignedUrl () {
      try {
        // S3オブジェクトの存在確認
        const officeIdList = this.listOffice.map(item => item.id.replace(':', '-'))
        const checkExistPreSignedUrlResult = await checkExistPreSignedUrl(this.campaign.id, officeIdList)
        const officeStatusList = checkExistPreSignedUrlResult.offices
        this.listOffice = this.listOffice.map(office => {
          const target = officeStatusList.find(status => status.office_id.replace('-', ':') === office.id)
          office.userListStatus = target.user_list_status
          office.completedListStatus = target.completed_list_status
          return office
        })
      } catch (e) {
        this.$emit('errorHandling', 'リストの取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async searchUser () {
      this.isLoading = true
      try {
        // ユーザー一覧検索
        const formatInput = this.getFormatInput()
        // 最初に1000件のみ取得
        const getSearchUserResult = await getSearchUser(formatInput, this.campaign.id, 1000)
        const listUser = getSearchUserResult.users
        this.nextToken = getSearchUserResult.next_token
        this.nextTokenSeconded = getSearchUserResult.next_token_seconded
        this.nextStartSeconded = getSearchUserResult.next_start_seconded
        const coursePacks = getSearchUserResult.coursePacks
        this.listUser = this.createFormtUserList(listUser, coursePacks)
        this.isSearch = true
        this.isLoading = false
      } catch (e) {
        this.$emit('errorHandling', 'ユーザーの取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
        this.isLoading = false
      }
    },
    async nextSearchUser () {
      const formatInput = this.getFormatInput()
      if (this.nextToken || this.nextTokenSeconded || this.nextStartSeconded) {
        this.isNextSearch = true
        try {
          const getSearchUserNextResult = await getSearchUserNext(formatInput, this.campaign.id, 4000, this.nextToken, this.nextTokenSeconded, this.nextStartSeconded)
          const listUserNext = getSearchUserNextResult.users
          this.nextToken = getSearchUserNextResult.next_token
          this.nextTokenSeconded = getSearchUserNextResult.next_token_seconded
          this.nextStartSeconded = getSearchUserNextResult.next_start_seconded
          const convertUserList = this.createFormtUserList(listUserNext)
          this.listUser = this.listUser.concat(convertUserList)
          this.isNextSearch = false
        } catch (e) {
          this.$emit('errorHandling', 'ユーザーの取得に失敗しました。' + e.errors[0].message)
          this.$log.debug(e)
          this.isNextSearch = false
        }
      }
    },
    createFormtUserList (listUser, coursePacks) {
      const convertListUser = listUser.map(item => {
        item.campaign_user_created_at = item.campaign_user_created_at ? dayjs.unix(item.campaign_user_created_at).format('YYYY-MM-DD') : '未登録'
        if (item.campaign_user_created_at !== '未登録') {
          item.continue_bonus_point = item.continue_bonus_point ? item.continue_bonus_point : 0
        }
        if (item.last_record_at) item.last_record_at = dayjs.unix(item.last_record_at).format('YYYY-MM-DD')
        const acn = item.certificate_number.split('-')
        item.symbol = acn[0]
        item.number = acn[1]
        item.checked = false
        if (item.selected_course_pack) {
          const selectedPack = coursePacks.find(pack => pack.id === item.selected_course_pack)
          item.selected_course_pack_name = selectedPack ? selectedPack.pack_name : null
        }
        item.total_steps = item.total_steps === null ? '未選択' : item.total_steps.toLocaleString() + '歩'
        item.current_walking_point = item.current_walking_point === null ? '未選択' : item.current_walking_point
        return item
      })
      return convertListUser
    },
    getFormatInput () {
      const formatInput = {}
      if (this.office_id_list) {
        if (this.office_id_list.value) {
          formatInput.office_id_list = this.office_id_list.value
        } else {
          formatInput.office_id_list = this.office_id_list
        }
      }
      if (this.affiliation_name) {
        formatInput.affiliation_name = this.affiliation_name
      }
      if (this.is_prizewinner !== false) {
        formatInput.is_prizewinner = this.is_prizewinner
      }
      if (this.advanced_course === 0 || this.advanced_course) {
        formatInput.advanced_course = parseInt(this.advanced_course)
      }
      if (this.completed_advanced_course === 0 || this.completed_advanced_course) {
        formatInput.completed_advanced_course = parseInt(this.completed_advanced_course)
      }
      if (this.team_name) {
        formatInput.team_name = this.team_name
      }
      if (this.is_continue_bonus_complete !== false) {
        formatInput.is_continue_bonus_complete = this.is_continue_bonus_complete
      }
      return formatInput
    },
    getFormatInputResultDetail (officeId) {
      const formatInput = {}
      formatInput.office_id_list = [officeId]
      return formatInput
    },
    async genearateCSVKey (type, officeId, user) {
      try {
        const csvFormat = 'SJIS'
        const request = {
          campaign_id: this.campaign.id,
          direction: 'ASC',
          input: {}
        }
        let pollingTime = 10000
        if (type === 'search_user') {
          this.searchCsvStatus = 'creating'
          const formatInput = this.getFormatInput()
          request.input = formatInput
        } else if (type === 'result_detail') {
          this.searchCsvStatus = 'creating_result_detail'
          const formatInput = this.getFormatInputResultDetail(officeId)
          request.input = formatInput
        } else if (type === 'user_result') {
          pollingTime = 3000
          this.searchCsvStatus = 'creating_user_result'
          request.input = { username: user.username, office_id_list: [] }
        }
        const getCsvGenerateKeyQueryResult = await getCsvGenerateKeyQuery(type, csvFormat, request)
        const s3Key = getCsvGenerateKeyQueryResult.s3_key
        // ポーリング処理
        let count = 0
        const loopCheckStatus = async () => {
          count += 1
          const getCsvCheckStatusQueryResult = await getCsvCheckStatusQuery(this.campaign.id, s3Key)
          const csvStatus = getCsvCheckStatusQueryResult.status
          if (csvStatus) {
            this.full_s3_key = getCsvCheckStatusQueryResult.s3_key
            this.searchCsvStatus = 'download'
          } else {
            // ポーリング（デフォルト10秒、結果詳細のみ3秒）
            const timeoutId = setTimeout(loopCheckStatus, pollingTime)
            // 15分間でタイムアウト
            if (count > 90) {
              clearTimeout(timeoutId)
              alert('タイムアウトが発生し、ダウンロードに失敗しました。')
              this.searchCsvStatus = 'untreated'
            }
          }
          // CSVダウンロード
          if (this.searchCsvStatus === 'download') {
            const getCsvCheckStatusQueryResult = await getCsvGetPreSignedUrlQuery(this.full_s3_key, this.campaign.id)
            const preSignedUrl = getCsvCheckStatusQueryResult.pre_signed_url
            const link = document.createElement('a')
            link.download = '.csv'
            link.href = preSignedUrl
            link.click()
            this.searchCsvStatus = 'untreated'
          }
        }
        loopCheckStatus()
      } catch (e) {
        this.$emit('errorHandling', 'ダウンロードに失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
        this.searchCsvStatus = 'untreated'
      }
    },
    async updateNote () {
      // 備考の一括編集
      if (!this.$refs.post_note_form.validate()) return
      this.isLoading = true
      const inputNote = this.note ? this.note : ''
      const userIdList = []
      this.listUser.forEach(item => {
        if (item.checked) {
          userIdList.push(item.enrollment_user_id.replace('EnrollmentUser:', ''))
        }
      })
      try {
        await registerUpdateNote(this.campaign.id, userIdList, inputNote)
        this.listUser.forEach(item => {
          if (item.checked) {
            item.checked = false
            item.note = inputNote
          }
        })
        this.note = ''
        this.resetSwitch = !this.resetSwitch
      } catch (e) {
        this.$emit('errorHandling', '備考の更新に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
      this.dialog = false
      this.isLoading = false
    },
    async downloadXlsx (officeId, listType) {
      try {
        // 署名付きurlの発行、Excelダウンロード
        const getUserListPreSignedUrlResult = await getUserListPreSignedUrl(officeId, listType, this.campaign.id)
        const preSignedUrl = getUserListPreSignedUrlResult.pre_signed_url
        const link = document.createElement('a')
        link.download = '.xlsx'
        link.href = preSignedUrl
        link.click()
      } catch (e) {
        this.$emit('errorHandling', 'ダウンロードに失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    createOfficeOptionsList (listOffice) {
      // 事業所選択リスト生成処理
      const formattedOptionList = listOffice.map(option => {
        return {
          text: option.name,
          value: [option.id]
        }
      })
      if (listOffice.length > 1) {
        formattedOptionList.unshift({
          text: '全事業所選択',
          value: listOffice.map(Office => Office.id)
        })
      }
      return formattedOptionList
    },
    createCourseOptionsList () {
      const courseOptionList = []
      for (let i = 0; i <= this.campaign.max_course_select; i++) {
        courseOptionList.push({
          text: i,
          value: i
        })
      }
      courseOptionList.unshift({
        text: '',
        value: ''
      })
      return courseOptionList
    },
    chancel () {
      this.dialog = false
      this.note = ''
      this.resetSwitch = !this.resetSwitch
    }
  }
}
</script>

<style scoped lang="scss">
.manage-group-title {
  margin-bottom: 1rem;
}
.group-table > .v-data-table ::v-deep div.v-data-footer__pagination {
  margin-left: auto;
  margin-right: 14px;
}
.group-table > .v-data-table ::v-deep th
, .user-table > .v-data-table ::v-deep th {
  border-right: 1px solid #c4c4c4 !important;
  background-color: #FFF8E1 !important;
}
.group-table > .v-data-table ::v-deep td
, .user-table > .v-data-table ::v-deep td {
  padding-left: 8px !important;
  padding-right: 4px !important;
  font-size: 0.8rem !important;
  border-right: 1px solid #c4c4c4 !important;
}
.user-table > .v-data-table ::v-deep div.v-data-table__wrapper {
  border: 1px solid #c4c4c4 !important;
  border-right: 0px !important;
  max-height: 550px;
}
.group-table > .v-data-table ::v-deep div.v-data-table__wrapper {
  border: 1px solid #c4c4c4 !important;
  border-right: 0px !important;
}
.user-table > .v-data-table ::v-deep div.v-data-footer {
  float: right;
}
</style>
